/* G&G Author Activity feed.
   Renders /apps/proxy/api/storefront/authors/activity into the section.
   Version: 2026-06-18-aac-r3-paged */
(function () {
  'use strict';
  try { console.log('[aac] author-activity.js v2026-06-18-aac-r3-paged'); } catch (e) {}

  function fmtMoney(a, c) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: c || 'USD' }).format(a); }
    catch (e) { return (a || 0).toFixed(2) + ' ' + (c || ''); }
  }
  // BUSINESS dates are rendered in the SHOP's time zone, never the viewer's.
  //
  // A bare toLocaleDateString() formats in whatever zone the browser sits in,
  // so the same sale showed one day to someone in Kyiv, another in the Shopify
  // admin (which is always shop time) and a third to a buyer in California.
  // The zone travels down in the API payload; until the first response lands we
  // fall back to the viewer's, which is the old behaviour and never worse.
  var SHOP_TZ = null;
  function setShopTz(tz) { if (tz) SHOP_TZ = tz; }
  function dateOpts(o) {
    var out = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = o[k];
    if (SHOP_TZ) out.timeZone = SHOP_TZ;
    return out;
  }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString(undefined, dateOpts({ day: 'numeric', month: 'short', year: 'numeric' })); } catch (e) { return iso; } }
  function el(tag, opts) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.className) n.className = opts.className;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.html != null) n.innerHTML = opts.html;
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
    }
    return n;
  }
  function svgEl(markup) { var d = document.createElement('div'); d.innerHTML = markup; return d.firstChild; }

  // Clean Lucide-style icons (24x24 stroke). Stored as inner markup.
  var ICONS = {
    sale: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    refund: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11"/>',
    payout_requested: '<circle cx="12" cy="12" r="10"/><path d="m16 12-4-4-4 4"/><path d="M12 16V8"/>',
    payout_paid: '<rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01"/><path d="M18 12h.01"/>',
    adjustment: '<line x1="21" x2="14" y1="4" y2="4"/><line x1="10" x2="3" y1="4" y2="4"/><line x1="21" x2="12" y1="12" y2="12"/><line x1="8" x2="3" y1="12" y2="12"/><line x1="21" x2="16" y1="20" y2="20"/><line x1="12" x2="3" y1="20" y2="20"/><line x1="14" x2="14" y1="2" y2="6"/><line x1="8" x2="8" y1="10" y2="14"/><line x1="16" x2="16" y1="18" y2="22"/>',
    job: '<rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
  };
  var LABELS = {
    sale: 'Sale', refund: 'Refund', payout_requested: 'Payout requested',
    payout_paid: 'Payout paid', adjustment: 'Adjustment', job: 'Custom service',
  };
  var GROUPS = [
    ['all', 'All', null],
    ['products', 'Products', ['sale', 'refund']],
    ['custom', 'Custom service', ['job']],
    ['payouts', 'Payouts', ['payout_requested', 'payout_paid']],
    ['adjustments', 'Adjustments', ['adjustment']],
  ];
  var SORTS = [['newest', 'Newest first'], ['oldest', 'Oldest first']];

  function init(root) {
    var inner = root.querySelector('.aac-inner');
    if (!inner) return;
    var isPreview = root.dataset.aacPreview === '1';
    if (!isPreview && inner.getAttribute('data-aac-is-author') !== '1') return;

    var els = {
      pending: inner.querySelector('[data-aac-pending]'),
      lifetime: inner.querySelector('[data-aac-lifetime]'),
      paid: inner.querySelector('[data-aac-paid]'),
      filters: inner.querySelector('[data-aac-filters]'),
      controls: inner.querySelector('[data-aac-controls]'),
      card: inner.querySelector('[data-aac-card]'),
      list: inner.querySelector('[data-aac-list]'),
      empty: inner.querySelector('[data-aac-empty]'),
      meta: inner.querySelector('[data-aac-meta]'),
    };
    var SEARCH_PH = (els.controls && els.controls.getAttribute('data-aac-search-ph')) || 'Search by order or job #';
    var PAGE_SIZE = 20; // events per page before paging kicks in

    var state = { events: [], currency: 'USD', filter: 'all', sort: 'newest', query: '', page: 1, controlsBuilt: false };

    function iconFor(type) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[type] || ICONS.adjustment) + '</svg>';
    }

    function renderSummary(b) {
      if (!b) return;
      if (els.pending) els.pending.textContent = fmtMoney(b.pendingBalance, b.currency);
      if (els.lifetime) els.lifetime.textContent = fmtMoney(b.totalEarned, b.currency);
      if (els.paid) els.paid.textContent = fmtMoney(b.totalPaid, b.currency);
    }

    function countFor(group) {
      if (!group) return state.events.length;
      return state.events.filter(function (e) { return group.indexOf(e.type) > -1; }).length;
    }

    function buildFilters() {
      els.filters.innerHTML = '';
      GROUPS.forEach(function (g) {
        var n = countFor(g[2]);
        if (g[0] !== 'all' && n === 0) return;
        var b = el('button', { className: 'aac-pill' + (state.filter === g[0] ? ' is-active' : ''), attrs: { type: 'button', role: 'tab', 'data-g': g[0] } });
        b.appendChild(el('span', { text: g[1] }));
        b.appendChild(el('span', { className: 'aac-pill-count', text: String(n) }));
        b.addEventListener('click', function () {
          state.filter = g[0];
          state.page = 1;
          els.filters.querySelectorAll('.aac-pill').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          renderList();
        });
        els.filters.appendChild(b);
      });
    }

    // Search box + sort dropdown (matches the dropdown language used elsewhere).
    function buildControls() {
      if (!els.controls || state.controlsBuilt) return;
      state.controlsBuilt = true;
      els.controls.innerHTML = '';

      // Search
      var search = el('div', { className: 'aac-search' });
      search.appendChild(svgEl('<svg class="aac-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>'));
      var input = el('input', { className: 'aac-search-input', attrs: { type: 'text', placeholder: SEARCH_PH, 'aria-label': SEARCH_PH } });
      var clear = el('button', { className: 'aac-search-clear', attrs: { type: 'button', 'aria-label': 'Clear search' } });
      clear.appendChild(svgEl('<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'));
      clear.style.display = 'none';
      var t;
      input.addEventListener('input', function () {
        clear.style.display = input.value ? 'inline-flex' : 'none';
        clearTimeout(t);
        t = setTimeout(function () { state.query = input.value.trim().toLowerCase(); state.page = 1; renderList(); }, 220);
      });
      clear.addEventListener('click', function () { input.value = ''; clear.style.display = 'none'; state.query = ''; state.page = 1; renderList(); input.focus(); });
      search.appendChild(input); search.appendChild(clear);
      els.controls.appendChild(search);

      // Sort dropdown (custom, coffee style)
      var dd = el('div', { className: 'aac-sort' });
      var trigger = el('button', { className: 'aac-sort-trigger', attrs: { type: 'button', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' } });
      trigger.appendChild(svgEl('<svg class="aac-sort-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 16 4 4 4-4"/><path d="M7 20V4"/><path d="M11 4h10"/><path d="M11 8h7"/><path d="M11 12h4"/></svg>'));
      var curSort = SORTS.filter(function (o) { return o[0] === state.sort; })[0] || SORTS[0];
      var valSpan = el('span', { className: 'aac-sort-value', text: curSort[1] });
      trigger.appendChild(valSpan);
      trigger.appendChild(svgEl('<svg class="aac-sort-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>'));
      var menu = el('div', { className: 'aac-sort-menu', attrs: { role: 'listbox' } });
      SORTS.forEach(function (o) {
        var opt = el('button', { className: 'aac-sort-option' + (o[0] === state.sort ? ' active' : ''), text: o[1], attrs: { type: 'button', role: 'option' } });
        opt.addEventListener('click', function () {
          state.sort = o[0]; valSpan.textContent = o[1]; state.page = 1;
          menu.querySelectorAll('.aac-sort-option').forEach(function (x) { x.classList.toggle('active', x === opt); });
          dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false');
          renderList();
        });
        menu.appendChild(opt);
      });
      trigger.addEventListener('click', function (e) { e.stopPropagation(); var open = dd.classList.toggle('open'); trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) { dd.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); } });
      dd.appendChild(trigger); dd.appendChild(menu);
      els.controls.appendChild(dd);
    }

    function visibleEvents() {
      var items = state.events.slice();
      // Type filter
      if (state.filter !== 'all') {
        var grp = GROUPS.filter(function (g) { return g[0] === state.filter; })[0];
        var types = grp && grp[2];
        if (types) items = items.filter(function (e) { return types.indexOf(e.type) > -1; });
      }
      // Search by order/job number or title.
      if (state.query) {
        var q = state.query.replace(/^#/, '');
        items = items.filter(function (e) {
          var hay = ((e.title || '') + ' ' + (e.status || '')).toLowerCase().replace(/#/g, '');
          return hay.indexOf(q) > -1;
        });
      }
      // Sort (newest default).
      items.sort(function (a, b) {
        var d = new Date(b.at).getTime() - new Date(a.at).getTime();
        return state.sort === 'oldest' ? -d : d;
      });
      return items;
    }

    function renderRow(e) {
      var row = el('div', { className: 'aac-row aac-row--' + e.type });
      row.appendChild(el('div', { className: 'aac-ic aac-ic--' + e.source, html: iconFor(e.type) }));

      var mid = el('div', { className: 'aac-mid' });
      var titleLine = el('div', { className: 'aac-row-title' });
      titleLine.appendChild(el('span', { text: e.title }));
      titleLine.appendChild(el('span', { className: 'aac-tag aac-tag--' + e.source, text: LABELS[e.type] || e.type }));
      mid.appendChild(titleLine);
      var sub = [fmtDate(e.at)];
      if (e.status) sub.push(e.status);
      mid.appendChild(el('div', { className: 'aac-row-sub', text: sub.join(' · ') }));
      row.appendChild(mid);

      var amt = e.amount;
      // Payouts get their OWN colour (not red) - it's an intentional
      // withdrawal, not a loss. Refunds stay red.
      var cls = e.source === 'payout' ? 'is-payout' : (amt > 0 ? 'is-pos' : amt < 0 ? 'is-neg' : 'is-zero');
      var txt = (amt > 0 ? '+ ' : amt < 0 ? '- ' : '') + fmtMoney(Math.abs(amt), e.currency || state.currency);
      row.appendChild(el('div', { className: 'aac-amt ' + cls, text: txt }));

      els.list.appendChild(row);
    }

    // Numbered pager under the list: < 1 2 3 … 8 >. Only shown when the
    // filtered list exceeds one page. Re-renders the current slice on click.
    function buildPager(total, totalPages, start) {
      var pager = el('div', { className: 'aac-pager' });
      pager.appendChild(el('span', { className: 'aac-pager-info',
        text: 'Showing ' + (start + 1) + '–' + Math.min(start + PAGE_SIZE, total) + ' of ' + total }));
      var nav = el('div', { className: 'aac-pager-nav' });

      function mkBtn(label, target, opts) {
        opts = opts || {};
        var b = el('button', { className: 'aac-pager-btn' + (opts.active ? ' is-active' : ''), text: label, attrs: { type: 'button' } });
        if (opts.disabled) b.disabled = true;
        else if (target != null) b.addEventListener('click', function () {
          state.page = target;
          renderList();
          if (els.card && els.card.scrollIntoView) els.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        return b;
      }

      nav.appendChild(mkBtn('‹', state.page - 1, { disabled: state.page === 1 }));
      var pages = [];
      for (var i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= state.page - 1 && i <= state.page + 1)) pages.push(i);
        else if (pages[pages.length - 1] !== '...') pages.push('...');
      }
      pages.forEach(function (p) {
        if (p === '...') nav.appendChild(el('span', { className: 'aac-pager-ellipsis', text: '…' }));
        else nav.appendChild(mkBtn(String(p), p, { active: p === state.page }));
      });
      nav.appendChild(mkBtn('›', state.page + 1, { disabled: state.page === totalPages }));
      pager.appendChild(nav);
      return pager;
    }

    function renderList() {
      var items = visibleEvents();
      els.list.innerHTML = '';
      var oldPager = els.card && els.card.querySelector('.aac-pager');
      if (oldPager) oldPager.parentNode.removeChild(oldPager);

      if (!items.length) {
        els.empty.hidden = false;
        els.empty.textContent = state.query ? 'Nothing matches your search.' : (els.empty.getAttribute('data-default') || 'No activity yet.');
        return;
      }
      els.empty.hidden = true;

      var totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
      if (state.page > totalPages) state.page = totalPages;
      if (state.page < 1) state.page = 1;
      var start = (state.page - 1) * PAGE_SIZE;
      items.slice(start, start + PAGE_SIZE).forEach(renderRow);

      if (totalPages > 1 && els.card) els.card.insertBefore(buildPager(items.length, totalPages, start), els.empty || els.meta || null);
    }

    function apply(data) {
      state.events = data.events || [];
      state.currency = data.currency || 'USD';
      renderSummary(data.balance);
      buildFilters();
      buildControls();
      renderList();
      if (els.meta) {
        var n = state.events.length;
        els.meta.textContent = n
          ? (n + ' event' + (n === 1 ? '' : 's') + (data.total > n ? ' (showing latest ' + n + ' of ' + data.total + ')' : ''))
          : '';
      }
    }

    function mock() {
      var now = Date.now();
      return {
        currency: 'USD', total: 6,
        balance: { currency: 'USD', pendingBalance: 1240.5, totalEarned: 3820, totalPaid: 2200, awaitingPayout: 0 },
        events: [
          { id: 's1', type: 'sale', title: 'Paper Box Mockup - High Angle', amount: 66.5, currency: 'USD', status: '#1217', source: 'product', at: new Date(now - 864e5 * 1).toISOString() },
          { id: 'j1', type: 'job', title: 'Brand identity pack', amount: 320, currency: 'USD', status: '#1043', source: 'custom_service', at: new Date(now - 864e5 * 2).toISOString() },
          { id: 'p1', type: 'payout_paid', title: 'Payout paid', amount: -740, currency: 'USD', status: 'PayPal', source: 'payout', at: new Date(now - 864e5 * 4).toISOString() },
          { id: 'a1', type: 'adjustment', title: 'Goodwill credit', amount: 25, currency: 'USD', status: 'goodwill', source: 'adjustment', at: new Date(now - 864e5 * 6).toISOString() },
          { id: 'r1', type: 'refund', title: 'Coffee Cup Mockup', amount: -52.5, currency: 'USD', status: '#1205', source: 'product', at: new Date(now - 864e5 * 9).toISOString() },
          { id: 'pr1', type: 'payout_requested', title: 'Payout requested', amount: -620, currency: 'USD', status: 'pending', source: 'payout', at: new Date(now - 864e5 * 12).toISOString() },
        ],
      };
    }

    function load() {
      if (isPreview) { apply(mock()); return; }
      fetch('/apps/proxy/api/storefront/authors/activity?take=120', { credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          if (!resp.ok) { if (els.meta) els.meta.textContent = (resp.json && resp.json.error) || 'Failed to load activity.'; return; }
          apply(resp.json);
        })
        .catch(function (e) { if (els.meta) els.meta.textContent = 'Failed to load activity: ' + e.message; });
    }

    load();
  }

  function boot() {
    document.querySelectorAll('.aac-wrapper').forEach(function (root) {
      if (root.dataset.aacInit === '1') return;
      root.dataset.aacInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
